import { Dialog, DialogContent, Button, Typography, Stack } from '@mui/material';
import DialogActionBar from './DialogActionBar';

interface RemoveLocationModalProps {
  open: boolean;
  onClose: () => void;
  onRemoveLocation: () => Promise<void>;
  loading?: boolean;
}

export default function RemoveLocationModal({
  open,
  onClose,
  onRemoveLocation,
  loading = false
}: RemoveLocationModalProps) {

  const handleRemove = async () => {
    try {
      await onRemoveLocation();
    } catch (error) {
      // Error handling is delegated to the parent component
      console.error('Remove location failed:', error);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      sx={{
        '& .MuiDialog-paper': {
          borderRadius: 2,
          width: '600px',
          maxWidth: '600px',
          height: 'auto',
          maxHeight: '90vh',
          pt: 4,
          px: 3,
          pb: 2
        },
      }}
    >
      <DialogContent sx={{ p: 0, mb: 3 }}>
        <Stack spacing={3}>
          <Stack spacing={2}>
            <Typography variant="h5">
              Remove Location?
            </Typography>
            <Typography variant="body1" sx={{
              color: "text.secondary"
            }}>
              Removing this location will disassociate any documents or participants related to this location.
            </Typography>
          </Stack>
        </Stack>
      </DialogContent>

      <DialogActionBar>
        <Button onClick={onClose} variant="outlined" size="medium">
          Cancel
        </Button>
        <Button 
          onClick={handleRemove} 
          variant="contained" 
          size="medium"
          color="error"
          disabled={loading}
        >
          {loading ? 'Removing...' : 'Remove Location'}
        </Button>
      </DialogActionBar>
    </Dialog>
  );
}